import axios from 'axios';

const request = axios.create({
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json',
    },
});

export { request };
